import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SatToCelestialBodyLine extends Line {
    sat;
    body;
    constructor(sat, body) {
        super();
        this.sat = sat;
        this.body = body;
        this.color_ = LineColors.CYAN;
    }
    update() {
        const eci = this.sat.eci(ServiceLocator.getTimeManager().simulationTimeObj);
        if (!eci) {
            this.isGarbage = true;
            return;
        }
        const eciArr = [eci.position.x, eci.position.y, eci.position.z];
        this.updateVertBuf([eciArr, ServiceLocator.getScene().getBodyById(this.body).position]);
    }
}
